module.exports = __webpack_public_path__ + "img/real_land_2.ddab9c04.png";